(function () {
  var root = document.getElementById('sbm-root');
  if (!root) return;
  var FN = (root.getAttribute('data-fn') || '').trim();
  var BOOKING_URL = root.getAttribute('data-booking') || '/pages/booking';
  var SERVICES_URL = root.getAttribute('data-services') || '/pages/services';
  var MKEY = 'saimaz_member_v1';
  var BKEY = 'saimaz_booking_v1';
  var pending = { phone: '', name: '', password: '' };

  function esc(s){ return String(s==null?'':s).replace(/[&<>"']/g,function(c){return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'})[c];}); }
  function money(v){ return 'Rs ' + Math.round(Number(v)||0).toLocaleString('en-PK'); }

  function getSession(){ try { return JSON.parse(localStorage.getItem(MKEY)) || null; } catch(e){ return null; } }
  function setSession(s){ if (s) localStorage.setItem(MKEY, JSON.stringify(s)); else localStorage.removeItem(MKEY);
    document.dispatchEvent(new CustomEvent('saimaz:member-change')); }

  function api(payload){
    return fetch(FN, { method:'POST', headers:{ 'Content-Type':'application/json' }, body: JSON.stringify(payload) })
      .then(function(r){ return r.json().then(function(j){ return { ok:r.ok, j:j }; }); });
  }

  function show(view){
    root.querySelectorAll('.sbm-view').forEach(function(v){ v.hidden = v.getAttribute('data-view') !== view; });
    var el = root.querySelector('.sbm-view[data-view="'+view+'"]');
    if (el){ var f = el.querySelector('input'); setTimeout(function(){ if (f) f.focus(); }, 80); }
    root.querySelectorAll('.sbm-err').forEach(function(e){ e.textContent=''; });
  }
  function open(){
    root.classList.add('sbm-open'); root.setAttribute('aria-hidden','false');
    if (getSession()) { show('dash'); loadDash(); } else { show('login'); }
  }
  function close(){ root.classList.remove('sbm-open'); root.setAttribute('aria-hidden','true'); }

  function busy(form, on, label){
    var b = form.querySelector('[data-go]');
    if (!b) return;
    if (on){ b.dataset.txt = b.textContent; b.disabled = true; b.textContent = label || 'Please wait...'; }
    else { b.disabled = false; if (b.dataset.txt) b.textContent = b.dataset.txt; }
  }
  function errIn(form, msg){ var e = form.querySelector('[data-err]'); if (e) e.textContent = msg || ''; }

  root.querySelector('[data-form-login]').addEventListener('submit', function(e){
    e.preventDefault(); var f = e.target; errIn(f,'');
    var phone = f.phone.value.trim(), password = f.password.value;
    if (phone.replace(/\D/g,'').length < 10) return errIn(f,'Please enter a valid mobile number.');
    if (!password) return errIn(f,'Please enter your password.');
    busy(f, true, 'Signing in...');
    api({ action:'login', phone:phone, password:password }).then(function(res){
      busy(f,false);
      if (!res.ok || res.j.error) return errIn(f, res.j.error || 'Could not sign in.');
      setSession({ token:res.j.token, name:res.j.member.name, phone:res.j.member.phone });
      show('dash'); loadDash();
    }).catch(function(){ busy(f,false); errIn(f,'Network error. Please try again.'); });
  });

  root.querySelector('[data-form-signup]').addEventListener('submit', function(e){
    e.preventDefault(); var f = e.target; errIn(f,'');
    var name = f.name.value.trim(), phone = f.phone.value.trim(), password = f.password.value;
    var confirm = f.confirm ? f.confirm.value : password;
    if (name.length < 2) return errIn(f,'Please enter your name.');
    if (phone.replace(/\D/g,'').length < 10) return errIn(f,'Please enter a valid mobile number.');
    if (password.length < 6) return errIn(f,'Password must be at least 6 characters.');
    if (password !== confirm) return errIn(f,'Passwords do not match.');
    busy(f, true, 'Please wait...');
    api({ action:'signup-start', name:name, phone:phone, password:password }).then(function(res){
      busy(f,false);
      if (!res.ok || res.j.error) return errIn(f, res.j.error || 'Could not create account.');
      if (res.j.token) {
        setSession({ token:res.j.token, name:res.j.member.name, phone:res.j.member.phone });
        show('dash'); loadDash(); return;
      }
      pending.phone = phone; pending.name = name; pending.password = password;
      root.querySelector('[data-otp-phone]').textContent = phone;
      show('otp');
    }).catch(function(){ busy(f,false); errIn(f,'Network error. Please try again.'); });
  });

  root.querySelector('[data-form-otp]').addEventListener('submit', function(e){
    e.preventDefault(); var f = e.target; errIn(f,'');
    var code = f.code.value.trim();
    if (!/^\d{6}$/.test(code)) return errIn(f,'Enter the 6-digit code.');
    busy(f, true, 'Verifying...');
    api({ action:'signup-verify', phone:pending.phone, code:code }).then(function(res){
      busy(f,false);
      if (!res.ok || res.j.error) return errIn(f, res.j.error || 'Invalid code.');
      setSession({ token:res.j.token, name:res.j.member.name, phone:res.j.member.phone });
      show('dash'); loadDash();
    }).catch(function(){ busy(f,false); errIn(f,'Network error. Please try again.'); });
  });
  root.querySelector('[data-otp-resend]').addEventListener('click', function(){
    var f = root.querySelector('[data-form-otp]');
    if (!pending.phone || !pending.password) { errIn(f, 'Please start signup again.'); return; }
    errIn(f, '');
    api({ action:'signup-start', phone:pending.phone, name:pending.name, password:pending.password }).then(function(res){
      if (!res.ok || res.j.error) { errIn(f, res.j.error || 'Could not resend the code.'); return; }
      errIn(f, 'A new code has been sent.');
    }).catch(function(){ errIn(f, 'Network error. Please try again.'); });
  });

  root.querySelector('[data-form-forgot]').addEventListener('submit', function(e){
    e.preventDefault(); var f = e.target; errIn(f,'');
    var phone = f.phone.value.trim();
    if (phone.replace(/\D/g,'').length < 10) return errIn(f,'Please enter a valid mobile number.');
    busy(f, true, 'Sending...');
    api({ action:'reset-start', phone:phone }).then(function(res){
      busy(f,false);
      pending.phone = phone;
      root.querySelector('[data-reset-phone]').textContent = phone;
      show('reset');
    }).catch(function(){ busy(f,false); errIn(f,'Network error. Please try again.'); });
  });
  root.querySelector('[data-reset-resend]').addEventListener('click', function(){
    if (pending.phone) api({ action:'reset-start', phone:pending.phone });
  });

  root.querySelector('[data-form-reset]').addEventListener('submit', function(e){
    e.preventDefault(); var f = e.target; errIn(f,'');
    var code = f.code.value.trim(), password = f.password.value;
    if (!/^\d{6}$/.test(code)) return errIn(f,'Enter the 6-digit code.');
    if (password.length < 6) return errIn(f,'Password must be at least 6 characters.');
    busy(f, true, 'Resetting...');
    api({ action:'reset-verify', phone:pending.phone, code:code, password:password }).then(function(res){
      busy(f,false);
      if (!res.ok || res.j.error) return errIn(f, res.j.error || 'Could not reset password.');
      setSession({ token:res.j.token, name:res.j.member.name, phone:res.j.member.phone });
      show('dash'); loadDash();
    }).catch(function(){ busy(f,false); errIn(f,'Network error. Please try again.'); });
  });

  function loadDash(){
    var s = getSession(); if (!s) { show('login'); return; }
    root.querySelector('[data-dash-name]').textContent = s.name || 'Member';
    var bookingsEl = root.querySelector('[data-dash-bookings]');
    bookingsEl.innerHTML = '<p class="sbm-muted">Loading...</p>';
    api({ action:'me', token:s.token }).then(function(res){
      if (!res.ok || res.j.error){ setSession(null); show('login'); return; }
      var d = res.j;
      setSession({ token:s.token, name:d.member.name, phone:d.member.phone });
      root.querySelector('[data-dash-name]').textContent = d.member.name || 'Member';
      var n = Number(d.stars || 0);
      var full = Math.max(0, Math.min(5, n));
      var starsHtml = '';
      for (var i=0;i<5;i++){ starsHtml += (i < full) ? '&#9733;' : '<span class="empty">&#9733;</span>'; }
      starsHtml += '<span class="lbl">' + n + (n===1?' visit':' visits') + '</span>';
      root.querySelector('[data-dash-stars]').innerHTML = starsHtml;
      var bk = d.bookings || [];
      if (!bk.length){ bookingsEl.innerHTML = '<p class="sbm-muted">No bookings yet. Tap &ldquo;Book an Appointment&rdquo; to get started.</p>'; }
      else {
        bookingsEl.innerHTML = bk.map(function(b){
          var cls = (b.status||'confirmed').toLowerCase();
          var svc = (b.services||[]).map(esc).join(', ');
          return '<div class="sbm-bk"><div class="sbm-bk-top">' +
            '<span class="sbm-bk-no">' + esc(b.booking_number||'Booking') + '</span>' +
            '<span class="sbm-pill ' + cls + '">' + esc(b.status||'') + '</span></div>' +
            (svc ? '<div class="sbm-bk-svc">' + svc + '</div>' : '') +
            '<div class="sbm-bk-meta">' + esc(b.date||'') + (b.time ? ' &middot; ' + esc(b.time) : '') +
              (b.total ? ' &middot; ' + money(b.total) : '') + '</div>' +
          '</div>';
        }).join('');
      }
      var vc = d.vouchers || [];
      var vwrap = root.querySelector('[data-vouchers-wrap]');
      var vlist = root.querySelector('[data-dash-vouchers]');
      if (vc.length){
        vwrap.hidden = false;
        vlist.innerHTML = vc.map(function(v){
          var val = v.discount_type === 'percent' ? (Number(v.discount_value)+'% off') : (money(v.discount_value)+' off');
          return '<div class="sbm-vc"><div class="sbm-vc-top">' +
            '<span class="sbm-vc-t">' + esc(v.title||val) + '</span>' +
            '<span class="sbm-vc-code">' + esc(v.code) + '</span></div>' +
            '<div class="sbm-vc-d">' + esc(val) + (v.valid_to ? ' &middot; valid till ' + esc(v.valid_to) : '') +
              (v.description ? ' &middot; ' + esc(v.description) : '') + '</div>' +
          '</div>';
        }).join('');
      } else { vwrap.hidden = true; }
    }).catch(function(){ bookingsEl.innerHTML = '<p class="sbm-muted">Could not load your account. Please try again.</p>'; });
  }

  root.querySelector('[data-dash-book]').addEventListener('click', function(){
    var hasBag = false;
    try { hasBag = (JSON.parse(localStorage.getItem(BKEY))||[]).length > 0; } catch(e){}
    close();
    location.href = hasBag ? BOOKING_URL : SERVICES_URL;
  });
  root.querySelector('[data-logout]').addEventListener('click', function(){
    var s = getSession(); if (s && s.token) api({ action:'logout', token:s.token });
    setSession(null); show('login');
  });

  root.addEventListener('click', function(e){
    var to = e.target.closest && e.target.closest('[data-to]');
    if (to){ show(to.getAttribute('data-to')); return; }
    if (e.target.closest && e.target.closest('[data-sbm-close]')) { close(); return; }
  });
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape') close(); });

  window.SaimazMember = {
    isLoggedIn: function(){ return !!getSession(); },
    getSession: getSession,
    getToken: function(){ var s = getSession(); return s ? s.token : ''; },
    open: open, close: close, refresh: loadDash
  };

  function isAccountTrigger(el){
    if (!el || !el.closest) return null;
    if (root.contains(el)) return null;
    return el.closest(
      'shopify-account, a[href$="/account"], a[href*="/account/login"], a[href*="/account?"], ' +
      '[aria-label*="account" i], [aria-label*="log in" i], [aria-label*="sign in" i], ' +
      'account-login-button, .header-actions__action--account'
    );
  }
  document.addEventListener('click', function(e){
    var t = isAccountTrigger(e.target);
    if (t){ e.preventDefault(); e.stopImmediatePropagation(); open(); }
  }, true);
})();